import { PropsWithChildren } from 'react';
import { IntegrationDataType } from '@mews-commander/data-access';
import { OptimusProvider, SuspenseBoundary } from '@mews-commander/ui';
import { AppError, useFeatureFlagService } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { TargetEnterpriseIdContextProvider, WithTargetEnterpriseId } from '../common';
import { updateComponentHandler } from '../updateComponentHandler';

interface EnterpriseIntegrationContainerProps extends Identifiable, WithTargetEnterpriseId {
    integrationName: IntegrationDataType;
}

export const EnterpriseIntegrationUpdateContainer = ({
    integrationName,
    targetEnterpriseId,
}: PropsWithChildren<EnterpriseIntegrationContainerProps>) => {
    const featureFlagService = useFeatureFlagService();
    const Component = updateComponentHandler(integrationName, { featureFlagService });

    if (!Component) {
        throw new AppError('Component not found');
    }

    return (
        <OptimusProvider density="spacious">
            <TargetEnterpriseIdContextProvider value={targetEnterpriseId}>
                <SuspenseBoundary>
                    <Component />
                </SuspenseBoundary>
            </TargetEnterpriseIdContextProvider>
        </OptimusProvider>
    );
};
